/**
 * Returns a random integer between and inclusive of the two values passed
 * @param minimum integer
 * @param maximum integer
 * @returns integer
 */
export const getRandomIntegerInclusive = (minimum: number, maximum: number) => {
  return Math.floor(Math.random() * (maximum - minimum + 1) + minimum);
};
